import React, { useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import { filter, liveClassStudentsState, selectStudent } from 'redux/liveClass/students.slices';
import { useAppDispatch, useAppSelector } from 'redux/hooks';
import { ReactComponent as Search } from 'assets/icons/search.svg';

import '../students.scoped.scss';
import '../../TeacherDashboard.scoped.scss';

const Students: React.FC = () => {
  const { students, loading, selectedStudents } = useAppSelector(liveClassStudentsState);
  const dispatch = useAppDispatch();
  const { t } = useTranslation('live_classes');

  useEffect(() => {
    if (loading === 'success') {
      dispatch(filter(''));
    }
  }, [loading]);

  useEffect(() => {
    dispatch(filter(''));
  }, [selectedStudents]);

  return (
    <>
      <div className="search-container">
        <input
          type="text"
          className="input margin-x-10px border-radius-20px full-width"
          placeholder={t('Search for student')}
          onChange={event => dispatch(filter(event.target.value))}
        />
        <Search className="icon" />
      </div>
      <div className="students-list-selected margin-x-10px">
        {students &&
          students.map(obj => {
            return (
              <div className="text-left w-100 single-student" key={obj.id}>
                <label htmlFor={`obj_${obj.id}`} className="checkbox-square">
                  <input
                    type="checkbox"
                    id={`obj_${obj.id}`}
                    checked={selectedStudents.indexOf(obj.id) > -1}
                    onChange={() => dispatch(selectStudent(obj.id))}
                  />
                  <span>{obj.full_name}</span>
                </label>
              </div>
            );
          })}
      </div>
    </>
  );
};

export default Students;
